// Броячите на „Складова база" (GET /inventory/nav-counts) — единствената
// дефиниция на заявката: ползват я значките в менюто (`useSidebarBadges`) и
// страница, която показва някой от броевете извън менюто (напр. „Чакат
// разнасяне: N отчета" в „Продадени") — кешът е един, втора заявка няма.
// В локален режим (каса без интернет) мълчи: касата не знае за склада. До BE
// без endpoint-а (404) `data` остава undefined.
import { useQuery } from "@tanstack/react-query";
import { getInventoryNavCounts } from "../api/inventoryNav";
import { useIsEdgeLocal } from "./useEdgeMode";

// `refetchInterval` го подава само менюто (`useSidebarBadges`) — значките се
// опресняват на минута, а страницата чете същия кеш без собствен таймер.
export const useInventoryNavCounts = (options: { refetchInterval?: number } = {}) => {
  const isLocal = useIsEdgeLocal();
  return useQuery({
    queryKey: ["inventory", "nav-counts"],
    queryFn: getInventoryNavCounts,
    enabled: !isLocal,
    retry: false,
    staleTime: 30_000,
    refetchInterval: options.refetchInterval,
  });
};
